/**
 * Build order_items rows from order state.
 * Returns an array of rows ready to be inserted into Supabase.
 * Each row has: order_id, item_type, product_id, side_id, flavor_id,
 *               preparation, quantity, price, name.
 */
export const buildOrderItems = (orderId, order) => {
  const rows = [];

  // 1) Main product (always present)
  if (order.product) {
    const flavorId = order.flavor?.id && order.flavor.id !== 'no-flavor' ? order.flavor.id : null;
    rows.push({
      order_id: orderId,
      item_type: 'main',
      product_id: order.product.id,
      side_id: null,
      flavor_id: flavorId,
      preparation: order.preparation?.name || null,
      quantity: 1,
      price: order.product.price,
      name: order.product.name,
    });
  }

  // 2) Burger upgrade (with optional sauce)
  if (order.burger) {
    const sauceName = order.burgerSauce?.name || 'Geen saus';
    const saucePrice = order.burgerSauce?.price || 0;
    rows.push({
      order_id: orderId,
      item_type: 'burger',
      product_id: null,
      side_id: null,
      flavor_id: null,
      preparation: null,
      quantity: 1,
      price: 1.50 + saucePrice,
      name: `Burger upgrade - ${sauceName}`,
    });
  }

  // 3) Optional sides
  if (order.extraSides?.length) {
    order.extraSides.forEach(side => {
      rows.push({
        order_id: orderId,
        item_type: 'side',
        product_id: null,
        side_id: side.id,
        flavor_id: null,
        preparation: null,
        quantity: side.quantity || 1,
        price: side.price,
        name: side.name,
      });
    });
  }

  return rows;
};
